export default "__VITE_ASSET__wB$oq_aB__"